import { Routes, Route, Navigate } from 'react-router-dom';
import { Daily } from './pages/Daily';
import { Settings } from './pages/Settings';
import { Support } from './pages/Support';
import './App.css';

export function App() {
    return (
        <div className="app">
            <Routes>
                <Route path="/" element={<Navigate to="/daily" replace />} />
                <Route path="/daily" element={<Daily />} />
                <Route path="/day/:date" element={<Daily />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/support" element={<Support />} />
            </Routes>
        </div>
    );
}

